angular.module('agreements')
    .component('agreementBtnOptions', {
        bindings: {
            item: '=',
            largeButton: '='
        },
        templateUrl: 'app/agreements/_btn-options.html',
        controller: function (AgreementService, FilesLibrary, FilesSimpleUploadService, Principal) {
            this.AgreementService = AgreementService
            this.FilesLibrary = FilesLibrary
            this.FilesSimpleUploadService = FilesSimpleUploadService

            this.isManager = Principal.hasAnyAuthority(["ROLE_CONTRACT_ALL", "ROLE_CONTRACT_PROJECT_ASSIGNED"]);
            this.canDelete = this.isManager;
            Principal.currentUser().then(user => {
                this.canPass = ['ORDER', 'OFFER'].includes(this.item.type) && (this.isManager || this.item.worker.id === user.id);
                this.canEdit = this.isManager || this.item.worker.id === user.id;
            })
        }
    })
